import * as amplitude from '@amplitude/analytics-browser';

import { Plan } from '../helpers/constants/plans';
import { AreaUnit } from '../graphql/graphql';

export default class AmplitudeAnalytics {
  static trackPlanSelect(planId: Plan) {
    amplitude.track('Plan Selected', { 'Plan Id': planId });
  }

  static trackPlanChange() {
    amplitude.track('Plan Changed');
  }

  static trackContactUs() {
    amplitude.track('Contact Us Clicked');
  }

  static trackAnnualPricingCalculated({
    area,
    areaUnit,
    userSeats,
    planetImagery,
  }: {
    area?: number;
    areaUnit?: AreaUnit;
    userSeats?: number;
    planetImagery?: number;
  }) {
    amplitude.track('Annual Pricing Calculated', {
      'Area Amount': area,
      'Area Unit': areaUnit,
      'User Seats': userSeats,
      'Planet Imagery': planetImagery,
    });
  }

  static trackMonthlyPricingCalculated({
    area,
    areaUnit,
    datasetImport,
    yieldCleaningCalibration,
    yieldSyntheticMapCreation,
    zonesMapCreation,
    equationMapCreation,
    samplingPlanCreation,
    exportZonesMap,
    userSeats,
    planetImagery,
  }: {
    area?: number;
    areaUnit?: AreaUnit;
    datasetImport?: number;
    yieldCleaningCalibration?: number;
    yieldSyntheticMapCreation?: number;
    zonesMapCreation?: number;
    equationMapCreation?: number;
    samplingPlanCreation?: number;
    exportZonesMap?: number;
    userSeats?: number;
    planetImagery?: number;
  }) {
    amplitude.track('Monthly Pricing Calculated', {
      'Area Amount': area,
      'Area Unit': areaUnit,
      'Dataset Import': datasetImport,
      'Yield Cleaning Calibration': yieldCleaningCalibration,
      'Yield Synthetic Map Creation': yieldSyntheticMapCreation,
      'Zones Map Creation': zonesMapCreation,
      'Equation Map Creation': equationMapCreation,
      'Sampling Plan Creation': samplingPlanCreation,
      'Export Zones Map': exportZonesMap,
      'User Seats': userSeats,
      'Planet Imagery': planetImagery,
    });
  }

  static trackSubscribeClicked(planId: Plan) {
    amplitude.track('Subscribe Clicked', { 'Plan Id': planId });
  }
}
